// ========== 必须写在所有代码最前面，路由实例化之前 ==========
(function() {
    const fullHref = window.location.href;
    // 剔除hash #后面内容，JS-SDK签名标准规则
    if (fullHref.includes('#')) {
        window.__wxEntryUrl = fullHref.split('#')[0];
    } else {
        window.__wxEntryUrl = fullHref;
    }
})();

import Vue from 'vue'
import App from './App.vue'

import router from './router/index'

import axios from "axios";
import VueAxios from 'vue-axios'

import Vant from 'vant';
import 'vant/lib/index.css';
import { isUnauthorizedError } from '@/tools/utils'

Vue.config.productionTip = false

if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', (event) => {
        if (isUnauthorizedError(event.reason)) {
            event.preventDefault()
        }
    })
}

Vue.use(Vant);
Vue.use(VueAxios, axios);

new Vue({
  //配置路由
  router: router,
  render: h => h(App),
}).$mount('#app')
